/* eslint-disable @typescript-eslint/naming-convention */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';

import { SmartForm } from 'components';
import { valueToInteger } from 'utils';
import { saveSetting, getSetting } from 'rdx/config';
import { addSuccess } from 'rdx/alert';

import { DBSchema, DisplaySchema } from './schema';
import './dbDisplay.scss';

function POSFunctions() {
  const dispatch = useDispatch();
  const DBDisplayRef = React.useRef(null);

  const touchpos_disable_local_database = useSelector(
    getSetting('touchpos_disable_local_database'),
  );
  const touchpos_allow_offline_mode = useSelector(
    getSetting('touchpos_allow_offline_mode'),
  );
  const touchpos_enable_customer_display_application = useSelector(
    getSetting('touchpos_enable_customer_display_application'),
  );
  const da_disable_discount_display = useSelector(
    getSetting('da_disable_discount_display'),
  );
  const customer_display_custom_panel = useSelector(
    getSetting('customer_display_custom_panel'),
  );

  const [configState, setConfigState] = useState({});

  useEffect(() => {
    setConfigState({
      touchpos_allow_offline_mode,
      touchpos_disable_local_database,
      touchpos_enable_customer_display_application,
      da_disable_discount_display,
      customer_display_custom_panel,
    });
  }, [
    touchpos_allow_offline_mode,
    touchpos_disable_local_database,
    touchpos_enable_customer_display_application,
    da_disable_discount_display,
    customer_display_custom_panel,
  ]);

  const submitSetting = () => {
    const { values: currentValues } = DBDisplayRef.current;

    Object.entries(currentValues).forEach(([key, value]) => {
      const payload = {};

      payload.parameterName = key;
      payload.parameterValue =
        typeof value === 'boolean' ? valueToInteger(value) : value;

      if (payload.parameterValue !== configState[key])
        dispatch(saveSetting(payload));
    });
  };

  const resetDBHandler = async (key, DBName = 'selected ') => {
    const payload = {
      parameterName: `reset-${key}`,
      parameterValue: Math.round(new Date().getTime() / 1000),
    };
    try {
      await dispatch(saveSetting(payload));
      dispatch(
        addSuccess(
          `Request received, please refresh your POS to reset the local ${DBName} database`,
        ),
      );
    } catch (error) {
      console.warn(error);
    }
  };

  return (
    <>
      <h3 className="db-support-header">Local database support</h3>
      <SmartForm
        grid
        autosave
        state={configState}
        ref={DBDisplayRef}
        fields={DBSchema}
        handleSubmit={submitSetting}
      />
      <h4>Reset local databases cache (Brazil POS)</h4>
      <div className="reset-cache-ctas">
        <Button
          variant="warning"
          size="sm"
          style={{ width: '350px' }}
          onClick={() => resetDBHandler('localProductsDB', 'products')}
        >
          Reset Local Product Cache
        </Button>
        <Button
          variant="warning"
          size="sm"
          style={{ width: '350px' }}
          onClick={() => resetDBHandler('localPricelistsDB', 'pricelists')}
        >
          Reset Local Pricelists Cache
        </Button>
        <Button
          variant="warning"
          size="sm"
          style={{ width: '350px' }}
          onClick={() => resetDBHandler('localCampaignsDB', 'campaigns')}
        >
          Reset Local Campaigns Cache
        </Button>
        <Button
          variant="warning"
          size="sm"
          style={{ width: '350px' }}
          onClick={() => resetDBHandler('localCouponsDB', 'coupons')}
        >
          Reset Local Coupons Cache
        </Button>
        <Button
          variant="warning"
          size="sm"
          style={{ width: '350px' }}
          onClick={() => resetDBHandler('localProductStockDB', 'product stock')}
        >
          Reset Local Product Stock Cache
        </Button>
      </div>
      <p>
        <strong>N.B.</strong> For reseting local products database in Berlin POS
        you need to go to the settings menu inside the Berlin POS
      </p>

      <h3 className="display-app-header">Display application</h3>
      <SmartForm
        grid
        autosave
        state={configState}
        ref={DBDisplayRef}
        fields={DisplaySchema}
        handleSubmit={submitSetting}
      />
    </>
  );
}

export default POSFunctions;
